import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyC-w3UQ2nIU8ZupD6-EFR6H_OceZBHRI0A",
    authDomain: "geo-shaped.firebaseapp.com",
    databaseURL: "https://geo-shaped.firebaseio.com",
    projectId: "geo-shaped",
    storageBucket: "geo-shaped.appspot.com",
    messagingSenderId: "511617278975",
    appId: "1:511617278975:web:8dec3736355a7725"
    // measurementId is optional - Firebase v10+ fetches it dynamically
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Shared Google provider instance for "Continue with Google" sign-in.
const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
}

// NOTE: there is intentionally no sign-in here anymore. The app used to
// auto-sign every visitor into a single shared service account so that
// Shares/Promos writes (which require request.auth != null) would succeed.
// That is now handled by AuthProvider (src/auth/AuthContext.jsx), which signs
// guests in *anonymously* and lets real users sign in with email or Google.
// Anonymous users still satisfy `request.auth != null`, so Shares keep working.

export { app, auth, storage, db, analytics, functions, googleProvider };